import Navbar from "../features/main/components/Navbar";
import Footer from "../features/main/components/Footer";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "../features/main/pages/HomePage";
import Blogs from "../features/main/pages/BlogsPage";
import Blogdetail from "../features/main/pages/BlogDetailsPage";
import Calender from "../features/main/pages/CalendarPage";
import AdminAuth from "../features/main/admin/AdminAuth";
import AdminEvents from "../features/main/admin/AdminEvents";
import Adminblogs from "../features/main/admin/AdminBlogs";
import NotFound from "../features/main/pages/NotFoundPage";
import IgsosaHome from "../features/igsosa/pages/HomePage";

export default function MainApp() {
  return (
    <>
      <Navbar />
      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:title" element={<Blogdetail />} />
          <Route path="/calender" element={<Calender />} />
          <Route path="/igsosa" element={<IgsosaHome />} />

          <Route path="/admin" element={<AdminAuth />} />
          <Route path="/admin/events" element={<AdminEvents />} />
          <Route path="/admin/blogs" element={<Adminblogs />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}
